import React from "react";
import './styles.scss';
import {useList} from "react-use";
import {TOTAL_DETAIL} from "../main-search/constant";

function PitcherAnalysis(props) {
    const {onChange, selected} = props;
    const [listRadio] = useList([
        {
            value: 1,
            name: '被打率'
        },{
            value: 2,
            name: '被本塁打'
        },{
            value: 3,
            name: '被長打率'
        },{
            value: 4,
            name: '被OPS'
        },{
            value: 5,
            name: '三振割合'
        },{
            value: 6,
            name: '四球割合'
        },{
            value: 7,
            name: 'ゴロ割合'
        },{
            value: 8,
            name: 'フライ割合'
        },{
            value: 9,
            name: 'ストライク率'
        },{
            value: 10,
            name: 'スイング率'
        },{
            value: 11,
            name: '奪空振り率'
        },{
            value: 12,
            name: '平均球速'
        },{
            value: 13,
            name: '最高球速'
        },{
            value: 14.1,
            name: '投球割合-ストレート'
        },{
            value: 14.2,
            name: '投球割合-シュート'
        },{
            value: 14.3,
            name: '投球割合-カットボール'
        },{
            value: 14.4,
            name: '投球割合-フォーク'
        },{
            value: 14.5,
            name: '投球割合-チェンジアップ'
        },{
            value: 14.6,
            name: '投球割合-スライダー'
        },{
            value: 14.7,
            name: '投球割合-シンカー'
        },{
            value: 14.8,
            name: '投球割合-カーブ'
        },{
            value: 14.9,
            name: '投球割合-その他'
        },
    ])
    return (
        <ul>
            {
                listRadio.map(item => {
                    return(
                        <li key={item.value}>
                            <label className="radio-detailed-search">{item.name}
                                <input type="radio" name="radio" checked={item.value === selected} value={item.value} onClick={() => onChange(item.value, TOTAL_DETAIL.COLUMN_GROUP)}/>
                                <span className="checkmark"/>
                            </label>
                        </li>
                    )
                })
            }
        </ul>
    )
}

export default PitcherAnalysis;
